/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import '@style/counter.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AmountInput } from '@components';
import { addCommas, removeNonNumeric, removeCommas } from '@helper';
const IsCash = ({ rate, repayMentTotalAmt }) => {
    const [isAllCash, setIsAllCash] = useState(false);
    const [show, setShow] = useState(false);
    const {
        PayOffStore: {
            getCashQry,
            repayMentPartInterest,
            payOffMoney,
            updateData,
            transInfoVisible,
            repaymentSwitchVisible,
            disableQueryInterest,
        },
        AuthStore: {
            borrowingAmount,
            maintenanceRatio,
            updateUserInfo,
            nextRealSyncTime,
        },
    } = useStore();
    useEffect(() => {
        let timeout;
        if (show) {
            timeout = setTimeout(() => setShow(false), 4000);
        }
        return () => clearTimeout(timeout);
    }, [show]);
    useEffect(() => {
        return () => {
            updateData('payOffMoney', '');
            updateData('repayMentPartInterest', 0);
        };
    }, []);

    return (
        <div>
            <div className="dest-mls  w-100 mt-4 mt-sm-0 mb-2 mb-sm-0 d-inline-block">
                <div className="float-sm-end  form-check form-switch">
                    <input
                        className="form-check-input border-0 "
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={isAllCash}
                        onChange={e => {
                            setIsAllCash(e.target.checked);
                            if (e.target.checked) {
                                updateData('payOffMoney', borrowingAmount);
                                updateData('repayMentPartInterest', 0);
                            } else {
                                updateData('payOffMoney', '');
                                updateData('repayMentPartInterest', 0);
                            }
                        }}
                    />
                    <label
                        className="form-check-label align-top"
                        htmlFor="flexSwitchCheckDefault"
                    >
                        全部還款
                    </label>
                </div>
            </div>
            <div id="cash-payoff">
                <ul className="mob-rev apply-info scrol-opacity table-responsive d-flex flex-nowrap justify-content-between align-items-end text-center mb-4 p-sm-2">
                    <li className=" px-1 pt-sm-0 pt-2 ">
                        <h6 className="red ds-fs-18">
                            {new Date().toLocaleDateString('zh-TW', {
                                timeZone: 'Asia/Taipei',
                            })}
                        </h6>
                        <small className="fs-12">還款日期</small>
                    </li>
                    <li className=" px-1 pt-sm-0 pt-2  position-relative">
                        <h6 className="red">
                            $<span>{addCommas(repayMentPartInterest)}</span>
                        </h6>
                        <small className="fs-12">還款利息</small>
                    </li>
                    <li className=" px-1 pt-2   pt-sm-0 m-rate-bg">
                        <div className=" rate-bg  d-sm-inline-block pt-sm-2  px-sm-3    text-white rounded-3">
                            <h6>
                                <span>
                                    {payOffMoney
                                        ? isAllCash
                                            ? 0
                                            : Math.floor(rate * 100) / 100
                                        : maintenanceRatio}
                                </span>
                                %
                            </h6>
                            <small className="fs-12">試算還款後維持率</small>
                        </div>
                    </li>
                </ul>
                <div className="formbox row mb-4">
                    <div className="col-12">
                        <label
                            htmlFor=" "
                            className="form-label"
                            onMouseOver={() => setShow(true)}
                            onMouseLeave={() => setShow(false)}
                        >
                            還款本金
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>最小單位為仟元</Tooltip>}
                                trigger="click"
                                show={show}
                            >
                                <i className="icon_point bi-exclamation-circle"></i>
                            </OverlayTrigger>
                        </label>
                        <label className="float-end">
                            {nextRealSyncTime &&
                                (() => {
                                    const date = new Date(nextRealSyncTime);
                                    // 確保 date 是有效的
                                    if (isNaN(date.getTime())) return null;

                                    const hours = date
                                        .getHours()
                                        .toString()
                                        .padStart(2, '0');
                                    const minutes = date
                                        .getMinutes()
                                        .toString()
                                        .padStart(2, '0');
                                    const seconds = date
                                        .getSeconds()
                                        .toString()
                                        .padStart(2, '0');

                                    return `資料更新時間: ${hours}:${minutes}:${seconds}`;
                                })()}
                        </label>
                        <li
                            className={`${
                                !payOffMoney ? '' : 'red-num position-relative'
                            }`}
                        >
                            {!payOffMoney ? (
                                ''
                            ) : (
                                <span className="fw-bolder position-absolute">
                                    $
                                </span>
                            )}

                            <AmountInput
                                type="tel"
                                className={`form-control  ${
                                    !payOffMoney ? '' : 'fw-bolder'
                                }`}
                                disabled={disableQueryInterest}
                                value={payOffMoney}
                                onChange={e => {
                                    let finalValue = e.target.value;
                                    if (
                                        parseInt(removeNonNumeric(finalValue)) >
                                        borrowingAmount
                                    ) {
                                        finalValue = borrowingAmount;
                                    }
                                    updateData(
                                        'payOffMoney',
                                        removeNonNumeric(finalValue)
                                    );
                                    if (
                                        parseInt(
                                            removeNonNumeric(finalValue)
                                        ) === borrowingAmount
                                    ) {
                                        setIsAllCash(true);
                                    } else {
                                        setIsAllCash(false);
                                    }
                                    if (payOffMoney !== finalValue) {
                                        updateData('repayMentPartInterest', 0);
                                    }
                                }}
                                onBlur={() => {
                                    if (
                                        parseInt(removeCommas(payOffMoney)) <
                                        1000
                                    ) {
                                        updateData('payOffMoney', '1000');
                                        setShow(true);
                                    }
                                    if (
                                        parseInt(removeCommas(payOffMoney)) >
                                        1000
                                    ) {
                                        updateData(
                                            'payOffMoney',
                                            removeNonNumeric(
                                                Math.floor(payOffMoney / 1000) *
                                                    1000
                                            )
                                        );
                                        setShow(true);
                                    }
                                }}
                                placeholder={`${
                                    !payOffMoney ? '請輸入還款金額' : ''
                                }`}
                            />
                        </li>
                    </div>
                    {/* 說明文字 */}
                    <p>
                        若有與營業員人工申請還款，或同時透過不同設備線上申請還款，請先確認已借金額正確性再送出申請。
                    </p>
                    {/* 還款總金額  */}
                    <div className="totalbox text-end  px-md-2 py-3">
                        <p className="price">
                            <label className="text-black2 align-text-bottom fw-bolder">
                                還款總金額
                            </label>
                            {/* {!repayMentPartInterest || !payOffMoney ? (
                                <b className="text-danger ps-3">
                                    尚未輸入還款金額
                                </b>
                            ) : (
                                <b className="red fit-3 ps-3">
                                    <span>$</span>
                                    {addCommas(repayMentTotalAmt)}
                                </b>
                            )} */}
                            {!repayMentPartInterest ? (
                                payOffMoney ? (
                                    <b className="text-danger ps-3">
                                        尚未查詢還款利息
                                    </b>
                                ) : (
                                    <b className="text-danger ps-3">
                                        尚未輸入還款金額
                                    </b>
                                )
                            ) : (
                                <b className="red fit-3 ps-3">
                                    <span>$</span>
                                    {addCommas(repayMentTotalAmt)}
                                </b>
                            )}
                        </p>
                    </div>
                </div>
            </div>
            <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                <button
                    className="btn_cancel m-border-0 btn rounded-pill text-end text-sm-center"
                    type="button"
                    onClick={() => {
                        updateData('payOffMoney', '');
                        updateData('repayMentPartInterest', 0);
                        setIsAllCash(false);
                    }}
                >
                    清 除
                </button>
                <button
                    className={`btn_check btn rounded-pill text-white ${
                        repayMentPartInterest ? 'd-none' : ''
                    }`}
                    type="button"
                    disabled={!payOffMoney || disableQueryInterest}
                    onClick={async e => {
                        e.preventDefault();
                        updateData('disableQueryInterest', true);
                        await getCashQry(payOffMoney);
                        // updateData(
                        //     'payOffMoney',
                        //     removeNonNumeric(
                        //         Math.floor(payOffMoney / 1000) * 1000
                        //     )
                        // );
                        // if (parseInt(payOffMoney) < 1000) {
                        //     updateData('payOffMoney', '1000');
                        //     setShow(true);
                        // }
                    }}
                >
                    {disableQueryInterest ? '利息查詢中...' : '查詢還款利息'}
                </button>

                <button
                    className={`btn_check btn rounded-pill text-white ${
                        !repayMentPartInterest ? 'd-none' : ''
                    }`}
                    type="button"
                    onClick={async e => {
                        e.preventDefault();

                        const [, getTransFlag, realSync, nextRealSyncTime] =
                            await updateUserInfo();
                        if (getTransFlag === '1') {
                            updateData(
                                'TransMsg',
                                '您已完成登入，系統資料尚在更新中，請稍候再申請。'
                            );
                        } else if (getTransFlag === '2') {
                            updateData('TransMsg', '作業中，請稍後再申請！');
                        }
                        if (getTransFlag === '1' || getTransFlag === '2') {
                            updateData('transFlagModalVisible', true);
                        } else {
                            updateData('transFlagModalVisible', false);
                            updateData('applyModalVisible', true);
                        }
                    }}
                    disabled={
                        !transInfoVisible ||
                        // 還款鎖定
                        !repaymentSwitchVisible
                    }
                >
                    申 請
                </button>
            </div>
        </div>
    );
};

export default observer(IsCash);
